<template>
    <div class="max-w-2xl mx-auto p-4">
        <h1 class="text-2xl font-semibold text-theme-base mb-2">
            Precios de entrega
        </h1>
        <p class="text-sm text-theme-muted mb-6">
            Precio de entrega por ciudad y el valor por defecto para ciudades
            que no tengan un precio configurado.
        </p>

        <div class="bg-theme-card rounded-xl p-6 flex flex-col gap-8">
            <section>
                <h2 class="text-lg font-medium text-theme-base mb-4">
                    Precios por ciudad
                </h2>
                <city-price-editor v-model="settings.deliveryPrices" />
            </section>

            <section>
                <h2 class="text-lg font-medium text-theme-base mb-4">
                    Precio para otras ciudades
                </h2>
                <div class="w-48">
                    <input-money-component
                        v-model="settings.unknownCitiesDefaultPrice"
                        border
                        label="Precio por defecto"
                        icon="💲"
                    />
                </div>
            </section>

            <div class="flex justify-end pt-2">
                <app-button :loading="isLoading" @click="save">
                    Actualizar
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import {
    defaultOrdersSettings,
    mapOrdersSettingsFromApi,
    mapOrdersSettingsToApi
} from "@/common/fields/orders-settings";

import CityPriceEditor from "@/components/utils/CityPriceEditor.vue";
import InputMoneyComponent from "@/components/utils/InputMoneyComponent.vue";

export default {
    name: "DeliveryPricesSettingsPage",
    components: { CityPriceEditor, InputMoneyComponent },
    layout: "app",
    data: () => ({
        isLoading: false,
        settings: defaultOrdersSettings()
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"])
    },
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if (
            !(await verifyPagePermission(
                "tenant:GetOrdersSettings",
                "/app/settings"
            ))
        )
            return;
        await this.loadSettings();
    },
    methods: {
        ...mapActions("tenants", [
            "getTenantOrdersSettings",
            "updateTenantOrdersSettings"
        ]),
        async loadSettings() {
            this.$loading.show();
            try {
                const data = await this.getTenantOrdersSettings();
                this.settings = mapOrdersSettingsFromApi(data);
                this.$loading.hide();
            } catch (error) {
                this.$loading.hide();
                this.$sound.play("error");
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async save() {
            this.$loading.show();
            this.isLoading = true;
            try {
                await this.updateTenantOrdersSettings(
                    mapOrdersSettingsToApi(this.settings)
                );
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.$loading.hide();
                this.isLoading = false;
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$sound.play("error");
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        }
    }
};
</script>
